import Pagination from "../../../../../../components/Pagination";
import Toast from "../../../../../../components/Toast";
import { useAppContext } from "../../../../../../context/AppContext";
import UserPageLayout from "../../../../components/UserPageLayout";
import { WithdrawalsData } from "../../network/api/WithdrawalsData";
import React, { useState, useEffect } from "react";
import { encodeId } from "../../../../../../utils/hash";
import { Link } from "react-router-dom";
import { WithdrawalData } from "../../network/api/WithdrawalData";
import ButtonLoader from "../../../../../../components/ButtonLoader";

export default function WithdrawalsAdmin() {
    const { setPageTitle, setPageUserID } = useAppContext();



    const [isLoading, setIsLoading] = useState(false);
    const [withdrawals, setWithdrawals] = useState([]);

    const [toastConfig, setToastConfig] = useState({
        visible: false,
        message: "",
        type: "primary",
    });

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: []
    });

    const [pageFilters, setPageFilters] = useState({
        page: null,
        limit: 10
    });

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pageProps.totalPages) {
            setPageProps((prev) => ({
                ...prev,
                page: page,
            }));

            setPageFilters((prev) => ({
                ...prev,
                page: page,
            }));
        }

    };

    const handleLimitChange = (value) => {
        setPageFilters((prev) => ({
            ...prev,
            limit: value,
        }));

    };

    const handleStatusChange = (value) => {
        setPageFilters((prev) => ({
            ...prev,
            status: value,
            page: 1,
        }));

    };

    useEffect(() => {
        const fetchWithdrawals = async () => {
            setIsLoading(true);
            const response = await WithdrawalsData({ pageFilters });
            
            if (response.status === "success") {

                setWithdrawals(response.data.data);
                setPageProps((prev) => ({
                    page: response.data.page,
                    totalPages: response.data.total_pages,
                    totalEntries: response.data.total_records,
                    entryLimit: response.data.limit,
                    visiblePages: response.data.visible_pages,
                }));
            } else {
                setToastConfig({
                    visible: true,
                    message: response.message,
                    type: "danger",
                });
            }
            setIsLoading(false);
        };

        fetchWithdrawals();
    }, [pageFilters]);

    const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleViewDetails = (withdrawal) => {
        setSelectedWithdrawal(withdrawal);
        setShowModal(true);
    };

    const [updatedStatus, setUpdatedStatus] = useState("approved");
    const [updatedReason, setUpdatedReason] = useState("");
    const handleSave = async (data) => {
        try {
            setIsLoading(true);
            const response = await WithdrawalData(data);
            if (response.status === "success") {
                setToastConfig({
                    visible: true,
                    message: "Withdrawal updated successfully.",
                    type: "success",
                });
                // Refresh the withdrawals list
                const refreshed = await WithdrawalsData({ pageFilters });
                if (refreshed.status === "success") {
                    setWithdrawals(refreshed.data.data);
                    setPageProps((prev) => ({
                        page: refreshed.data.page,
                        totalPages: refreshed.data.total_pages,
                        totalEntries: refreshed.data.total_records,
                        entryLimit: refreshed.data.limit,
                        visiblePages: refreshed.data.visible_pages,
                    }));
                }
            } else {
                setToastConfig({
                    visible: true,
                    message: response.message || "Failed to update withdrawal.",
                    type: "danger",
                });
            }

        } catch (error) {
            setToastConfig({
                visible: true,
                message: `Failed to update withdrawal...${error}`,
                type: "danger",
            });
        } finally {
            setIsLoading(false);
            setShowModal(false);
            setSelectedWithdrawal(null);
            setUpdatedStatus("approved");
            setUpdatedReason("");
        }
    }


    useEffect(() => {
        setPageUserID(null);
        setPageTitle("Withdrawals");
    }, [setPageTitle, setPageUserID]);

    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row" key={`withdrawals-hjjk`}>
                        {isLoading && (
                            <div className="text-center my-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}

                        <div className="col-lg-12">
                            <Toast message={toastConfig.message}
                                type={toastConfig.type}
                                visible={toastConfig.visible}
                                setVisible={(visible) => setToastConfig({ ...toastConfig, visible })} />
                            <div className="card custom-card">

                                <div className="card-body">
                                    <div id="guestTable-all-1_wrapper" className="table-responsive dataTables_wrapper no-footer ">
                                        <div className="dataTables_length me-4" id="page_limit">
                                            <label>
                                                Show{" "}
                                                <select
                                                    name="page_limit"
                                                    aria-controls="example3"
                                                    className=""
                                                    value={pageProps.entryLimit}
                                                    onChange={(e) => handleLimitChange(Number(e.target.value))}

                                                >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>{" "}
                                                entries
                                            </label>
                                        </div>
                                        <div className="dataTables_length" id="page_limit">
                                            <label>
                                                Status{" "}
                                                <select
                                                    name="status"
                                                    aria-controls="example3"
                                                    className=""
                                                    value={pageFilters.status || "all"}

                                                    onChange={(e) => handleStatusChange(e.target.value)}

                                                >
                                                    <option value="">all</option>
                                                    <option value="approved">approved</option>
                                                    <option value="pending">pending</option>
                                                    <option value="rejected">rejected</option>
                                                </select>
                                            </label>
                                        </div>
                                        <div id="example3_filter" className="dataTables_filter">
                                            <label>
                                                Search:
                                                <input
                                                    type="search"
                                                    className=""
                                                    placeholder=""
                                                    aria-controls="example3"

                                                />
                                            </label>
                                        </div>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>User</th>
                                                    <th>Amount</th>
                                                    <th>Method</th>
                                                    <th>Status</th>
                                                    <th>Reason</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {withdrawals?.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="8" className="text-center py-5">
                                                            <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                                                                <i className="fa fa-folder-open fa-3x mb-3"></i>
                                                                <p className="mb-0">No Withdrawals found</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    withdrawals?.map((withdrawal) => (
                                                        <tr key={`withdrawal-${withdrawal.id}`}>
                                                            <td>{withdrawal.id}</td>
                                                            <td><Link to={`/users/${encodeId(withdrawal.user_id)}/profile`}>{withdrawal.fullname}</Link></td>
                                                            <td>${parseFloat(withdrawal.amount).toFixed(2)}</td>
                                                            <td>
                                                                <div className="border rounded shadow-sm p-2">
                                                                    {/* Header */}
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <strong className="text-capitalize">{withdrawal.method}</strong>
                                                                        <i className="bi bi-key-fill text-secondary"></i>
                                                                    </div>

                                                                    {/* Key-Value pairs */}
                                                                    {withdrawal.account_details && Object.keys(withdrawal.account_details).length > 0 ? (
                                                                        <div>
                                                                            {Object.entries(withdrawal.account_details).map(([key, value]) => (
                                                                                <div key={key} className="d-flex justify-content-between border-bottom py-1">
                                                                                    <span className="text-muted text-capitalize">{key}</span>
                                                                                    <span className="fw-semibold text-break text-end ms-2">{value}</span>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        <p className="text-muted mb-0 small">No details available</p>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span className={`badge ${withdrawal.status === "approved" ? "bg-success" : withdrawal.status === "pending" ? "bg-warning" : "bg-danger"}`}>
                                                                    {withdrawal.status}
                                                                </span>
                                                            </td>
                                                            <td className="text-wrap text-break" style={{ maxWidth: "300px" }}>
                                                                {withdrawal.reason || "-"}
                                                            </td>
                                                            <td>{new Date(withdrawal.created_at).toLocaleString()}</td>
                                                            <td className="py-2 px-2 text-end align-middle">
                                                                <div className="dropdown text-sans-serif">
                                                                    <button className="btn btn-primary tp-btn-light sharp" type="button" data-bs-toggle="dropdown">
                                                                        <span><i className="fa fa-ellipsis-v"></i></span>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end border py-0">
                                                                        <div className="py-2">
                                                                            <button className="dropdown-item" onClick={() => handleViewDetails(withdrawal)}>Action</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                        <Pagination
                                            pageProps={pageProps}
                                            onPageChange={handlePageChange} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && selectedWithdrawal && (
                <div className="modal show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content border-0 shadow">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {selectedWithdrawal.fullname} — Withdrawal #{selectedWithdrawal.id}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                {/* Current status badge */}
                                <div className="mb-3">
                                    <span className="fw-bold me-2">Current Status:</span>
                                    <span
                                        className={`badge bg-${selectedWithdrawal.status === "approved"
                                            ? "success"
                                            : selectedWithdrawal.status === "pending"
                                                ? "warning text-dark"
                                                : "danger"
                                            }`}
                                    >
                                        {selectedWithdrawal.status}
                                    </span>
                                </div>

                                {/* Status update form */}
                                <div className="mb-3">
                                    <label htmlFor="statusSelect" className="form-label fw-semibold">
                                        Update Status
                                    </label>
                                    <select
                                        id="statusSelect"
                                        className="form-select"
                                        value={updatedStatus}
                                        onChange={(e) => setUpdatedStatus(e.target.value)}
                                    >
                                        <option value="approved"><span className="text-success">Approved</span></option>
                                        <option value="rejected"><span className="text-danger">Rejected</span></option>
                                    </select>
                                </div>

                                {/* Reason textarea */}
                                <div className="mb-3">
                                    <label htmlFor="reasonTextarea" className="form-label fw-semibold">
                                        Reason / Notes
                                    </label>
                                    <textarea
                                        id="reasonTextarea"
                                        className="form-control"
                                        rows="3"
                                        placeholder="Enter reason for this status..."
                                        value={updatedReason}
                                        onChange={(e) => setUpdatedReason(e.target.value)}
                                    ></textarea>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() =>
                                        handleSave({
                                            id: selectedWithdrawal.id,
                                            status: updatedStatus,
                                            reason: updatedReason,
                                        })
                                    }
                                >
                                    {isLoading ? <ButtonLoader /> : ("Save changes")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </UserPageLayout>
    );
} 